import cx from "classnames"
import { Children, isValidElement } from "react"
import { Icon, type IconColorsType, type IconSources } from "../Icon"

const ICON_SIZE = 20
export interface PillPropsType {
  children: React.ReactNode
  icon?: IconSources
  color?: IconColorsType
  size?: "large"
  overlayed?: boolean
  className?: string
}

export const Pill = ({
  icon,
  color = "onSurface",
  children,
  overlayed,
  className,
  size,
}: PillPropsType) => {
  const iconMarkup = icon ? (
    <span className="cobalt-Pill__Icon">
      <Icon
        source={icon}
        size={ICON_SIZE}
        color={overlayed ? "surfaceFixed" : color}
      />
    </span>
  ) : null

  return (
    <div
      className={cx(className, "cobalt-Pill", {
        "cobalt-Pill--colorConnect": color === "connect",
        "cobalt-Pill--overlayed": overlayed,
        "cobalt-Pill--large": size === "large",
      })}
    >
      {iconMarkup} {children}
    </div>
  )
}

export interface PillGroupPropsType {
  children: React.ReactNode
}

export const PillGroup = ({ children }: PillGroupPropsType) => {
  return (
    <div className="cobalt-PillGroup">
      {Children.toArray(children).map((child, index) => {
        const childKey =
          isValidElement(child) && child.key != null
            ? child.key
            : `pill-group-item-${index}`
        return (
          <div className="cobalt-PillGroup__Item" key={childKey}>
            {child}
          </div>
        )
      })}
    </div>
  )
}

export default Pill
